import { useTranslation } from "react-i18next";
import { useProductDescriptorContext } from "~/domains/product/ProductContext";
import RichTooltip from "~/common/components/RichTooltip/RichTooltip";
import { Button, Typography } from "~/common/mui";
import parse from "html-react-parser";
import { URL_RECONDITIONABLE } from "~/utils/url/staticUrls";
import Tag from "~/common/components/Tag/Tag";
import Cycle from "~/common/mui/icons/Cycle";

export const ReconditionableTag = () => {
  const { t } = useTranslation();
  const descriptor = useProductDescriptorContext();
  if (!descriptor.base.reconditionable) {
    return null;
  }
  return (
    <RichTooltip
      content={<Typography>{parse(t("cmsnavigationnode.schaefflerContentCatalog.reconditionableInfo"))}</Typography>}
      actions={[
        <Button href={URL_RECONDITIONABLE} variant="text">
          {t("cmsnavigationnode.schaefflerContentCatalog.moreInfo")}
        </Button>,
      ]}
    >
      <Tag icon={<Cycle fontSize="small" />} iconPosition="start" variant="success">
        {t("cmsnavigationnode.schaefflerContentCatalog.reconditionable")}
      </Tag>
    </RichTooltip>
  );
};
